<template>
  <div class="exchange-detail detail-padding padding-nav">
    <el-button @click="goback" type="text" class="upper" style="margin-bottom:0.16rem;" icon="el-icon-d-arrow-left">Go
      back</el-button>
    <div class="spaceBetween" style="margin-bottom:0.24rem">
      <div class="spaceLeft">
        <div class="detail-title-1">My bidding history</div>
      </div>
      <div class="spaceLeft search-form">
        <!-- <div class="sapceLeft search-item">
          <el-checkbox v-model="searchParams.isExtractedUSTN" @change="getList">Not extracted  USTN</el-checkbox>
        </div> -->
        <div class="sapceLeft search-item">
          <el-checkbox v-model="searchParams.isExtractedUnit" @change="getList">Not extracted Unit</el-checkbox>
        </div>
        <search-date @dateChange="dateChange($event, 'overtime')" label="Closing time" />
        <div class="sapceLeft search-item">
          <el-input v-model="searchParams.number" placeholder="No..." suffix-icon="el-icon-search" @change="getList" />
        </div>
      </div>
    </div>
    <div class="common-card">
      <el-table class="common-table" :data="tableList" v-loading="loading" highlight-current-row>
        <el-table-column prop="number" label="No." align="left" width="80px">
          <template slot-scope="{ row }">
            {{ row.number }}
          </template>
        </el-table-column>
        <el-table-column prop="overtime" label="Closing Time" width="220">
          <template slot-scope="{ row }">
            {{ moment.utc(row.overtime).format("YYYY-MM-DD HH:mm:ss") }}
          </template>
        </el-table-column>
        <el-table-column prop="auction" label="Auction" align="right" width="120">
          <template slot-scope="{ row }">
            <big-number :number="row.amount" /><span class="td-word-sm">UNIT</span>
          </template>
        </el-table-column>
        <el-table-column prop="highValue" label="Current Bid" align="right" width="120">
          <template slot-scope="{ row }">
            <big-number :number="row.highValue" /><span class="td-word-sm">TCash</span>
          </template>
        </el-table-column>
        <el-table-column prop="account" label="Winning Bidder" show-overflow-tooltip width="150">
          <template slot-scope="{ row }">
            <account :value="getWinner(row)" />
          </template>
        </el-table-column>
        <el-table-column prop="data5" label="My bid" width="280">
          <template slot-scope="{ row }">
              <div style="display: flex;align-items: center;">
                <big-number :number="row.auctiondetail[0] && row.auctiondetail[0].amount" /> TCash
            <div class="td-word-sm" style="margin-left:0.1rem;">{{ moment.utc(row.timestamp).format("YYYY-MM-DD HH:mm:ss") }}
            </div>
              </div>
          </template>
        </el-table-column>
        <el-table-column prop="status" label="TCash withdrawal status" align="center" width="200">
          <template slot-scope="{ row }">
            <!-- <el-button type="text" class="status" @click="extractDialog(1, row)" v-if="showUSTNBtn(row)">
              <i class="iconfont trn-tiqu" />
              Withdraw Tcash
            </el-button> -->
            <span v-if="showUSTNBtn(row)" class="xiaohao"><i class="iconfont trn-xiaohao" />Not extracted</span>
            <span v-else-if="row.auctiondetail[0] && row.auctiondetail[0].extractStatus == 2" class="xiaohao"><i
                class="iconfont trn-xiaohao" />Extracted</span>
            <span v-else>--</span>
          </template>
        </el-table-column>
        <el-table-column width="150" prop="data7" label="Auction status" align="center">
          <template slot-scope="{ row }">
            <!-- <el-button type="text" class="status" @click="extractDialog(2, row)" v-if="showUnitBtn(row)">
              <i class="iconfont trn-tiqu" />
              Withdraw winnings
            </el-button> -->
            <span v-if="showUnitBtn(row)" class="xiaohao"><i class="iconfont trn-xiaohao" />Not extracted</span>
            <span v-else-if="row.status == 3" class="xiaohao"><i class="iconfont trn-xiaohao" />Extracted</span>
            <span v-else>--</span>
          </template>
        </el-table-column>
        <el-table-column width="500" prop="oper" label="Operation" align="left">
          <template slot-scope="{ row }">
            <el-button type="text" class="o-btn" @click="extractDialog(1, row)" v-if="showUSTNBtn(row)">
              <!-- <i class="iconfont trn-tiqu" /> -->
              Extract Tcash
            </el-button>
            <el-button type="text" class="o-btn" @click="extractDialog(2, row)" v-if="showUnitBtn(row)">
              <!-- <i class="iconfont trn-tiqu" /> -->
              Extract UNIT
            </el-button>
            <el-button type="text" class="o-btn" v-if="!isOver(row.overtime)" @click="toAdd(row)">Add bid</el-button>
            <el-button type="text" class="o-btn" @click="toDetail(row)">Details</el-button>
          </template>
        </el-table-column>
      </el-table>
      <pagination :total.sync="queryParams.total" :page.sync="queryParams.page" :limit.sync="queryParams.pageSize"
        @pagination="getList()" />
    </div>
    <extractBidsDialog ref="extractBidsDialog" @refresh="getList" />
  </div>
</template>

<script>
import extractBidsDialog from "./extractBidsDialog.vue"
import { myHistorylist } from "@/api/auction.js"
import { deepClone } from "@/utils/index.js"
export default {
  components: { extractBidsDialog },
  data() {
    return {
      loading: false,
      searchParams: {
        isExtractedUSTN: false,
        isExtractedUnit: undefined,
        overtime: [],
        number: undefined
      },
      queryParams: {
        total: 0,
        page: 1,
        pageSize: 10
      },
      tableList: [],
    };
  },
  computed: {},
  methods: {
    dateChange(data, prop) {
      this.searchParams[prop] = data;
      this.getList();
    },
    getList() {
      this.loading = true;
      myHistorylist({
        account: this.$store.getters.metaMaskObj.account,
        page: this.queryParams.page,
        pageSize: this.queryParams.pageSize,
        status: this.searchParams.isExtractedUnit ? [1, 2] : undefined,
        overTimeFrom: this.searchParams.overtime[0] ? this.moment(this.searchParams.overtime[0]).format("x") : undefined,
        overTimeTo: this.searchParams.overtime[1] ? this.moment(this.searchParams.overtime[1]).format("x") : undefined,
        number: this.searchParams.number,
        sortField: "timestamp",
        sequence: "DESC"
      }).then(res => {
        this.tableList = res.data ? res.data.data : [];
        this.queryParams.total = res.data.total || 0;
        this.loading = false;
      }).catch(err => {
        console.log(err);
        this.loading = false;
      })
    },
    getTranfer(val) {
      switch (val) {
        case "FALSE":
          return { text: "To extract", class: "status-1", icon: "trn-tiqu" };
        case "SUCCESS":
          return { text: "Succeeded", class: "status-2", icon: "trn-tiqu" };
        case "3":
          return { text: "Extracted", class: "status-3", icon: "trn-xiaohao" }
      }
    },
    getWinner(row) {
      let isOver = new Date(row.overtime).getTime() <= new Date().getTime();
      if (isOver) {
        return row.topAuction && row.topAuction.account;
      }
      return "";
    },
    showUSTNBtn(row) {
      let topAcc = row.topAuction && row.topAuction.account;
      return row.auctiondetail && row.auctiondetail[0] && row.auctiondetail[0].extractStatus == 1 && topAcc != this.$store.getters.metaMaskObj.account;
    },
    showUnitBtn(row) {
      let winner = this.getWinner(row);
      let isOver = new Date(row.overtime).getTime() <= new Date().getTime();
      return row.status == 2 && winner == this.$store.getters.metaMaskObj.account && isOver;
    },
    isOver(overtime) {
      return new Date(overtime).getTime() <= new Date().getTime();
    },
    extractDialog(type, row) {
      this.$refs.extractBidsDialog.open({
        type: type,
        row
      })
    },
    toDetail(row) {
      let obj = deepClone(row);
      delete obj.auctiondetail;
      delete obj.winner;
      obj.myBid = row.auctiondetail && row.auctiondetail[0] && row.auctiondetail[0].amount || 0;
      obj.winner = this.getWinner(row);

      this.$router.push({
        path: "/TCashFinance/auction/placeBid/detail",
        query: {
          ...obj
        }
      })
    },
    toAdd(row) {
      let obj = deepClone(row);
      delete obj.auctiondetail;
      delete obj.winner;
      delete obj.othertime;
      obj.myBid = row.auctiondetail && row.auctiondetail[0] && row.auctiondetail[0].amount || 0;
      obj.winner = row.winner && row.winner[0] && row.winner[0].account;
      obj.startTime = row.othertime && row.othertime.length && row.othertime[row.othertime.length - 1].timestamp;

      this.$router.push({
        path: "/TCashFinance/auction/placeBid",
        query: {
          ...obj,
          fromPath: "/TCashFinance/auction/placeBid/record"
        }
      })
    },
    goback() {
      this.$router.push("/TCashFinance/auction");
    }
  },
  created() {
    this.getList();
  },
  mounted() { 
    // this.$nextTick(() => {
    //   this.$refs.extractBidsDialog.open({
    //     type: 1,
    //     row: {
    //       number: 1,
    //       amount: 100,
    //     }
    //   })
    // })
  }
};
</script>
<style scoped lang="scss">
.detail-padding {
  padding-left: 10%;
  padding-right: 10%;
}

.exchange-detail {
  .td-type-img {
    width: 0.52rem;
    margin-right: 0.16rem;
  }
}

.status {
  border-radius: 0.04rem;
  color: #1F1F1F;
  padding: 0.07rem 0.12rem;
  font-size: 0.15rem;
  color: #3172FD;

  i {
    color: #3172FD;
    margin-right: 0.09rem;
  }

}

.xiaohao {
  font-size: 0.15rem;
  color: #fff;

  i {
    color: #2E9571;
    margin-right: 0.06rem;
  }
}

.search-item::v-deep input {
  border: 1px solid rgba(255, 255, 255, 0.2) !important;
}

.common-table {
  ::v-deep .el-loading-mask {
    background-color: rgba(0, 0, 0, .6);
  }

  ::v-deep .el-loading-spinner .path {
    stroke: #2675f1;
  }

  .o-btn {
    width: 1.12rem;
    height: 0.44rem;
    border-radius: 0.06rem;
    font-size: 0.18rem;
    background: linear-gradient(264deg, #225bfc 0%, #062567 100%);
    cursor: pointer;
    color: #fff !important;
    border: 0;
  }
}
</style>
